import { defineMessages } from 'react-intl';
export default defineMessages({
    away: {
        id: 'thermostat.away',
        defaultMessage: 'Away'
    },
    boilerOn: {
        id: 'thermostat.boilerOn',
        defaultMessage: 'Boiler ON'
    },
    hg: {
        id: 'thermostat.hg',
        defaultMessage: 'Frost guard'
    },
    homeInformation: {
        id: 'thermostat.homeInformation',
        defaultMessage: 'Home information'
    },
    homeName: {
        id: 'thermostat.homeName',
        defaultMessage: 'Home name'
    },
    manualBoost: {
        id: 'thermostat.manualBoost',
        defaultMessage: 'Manual boost'
    },
    manualSetpointUntil: {
        id: 'thermostat.manualSetpointUntil',
        defaultMessage: 'Manual setpoint until'
    },
    noThermostatYet: {
        id: 'thermostat.noThermostatYet',
        defaultMessage: "You don't have a thermostat yet."
    },
    relay: {
        id: 'thermostat.relay',
        defaultMessage: 'Relay'
    },
    room: {
        id: 'thermostat.room',
        defaultMessage: 'Room'
    },
    roomAnticipating: {
        id: 'thermostat.roomAnticipating',
        defaultMessage: 'Heating early for the next scheduled temperature'
    },
    roomOpenWindow: {
        id: 'thermostat.roomOpenWindow',
        defaultMessage: 'Open window detected, heating paused'
    },
    rooms: {
        id: 'thermostat.rooms',
        defaultMessage: 'Rooms'
    },
    smartThermostat: {
        id: 'thermostat.smartThermostat',
        defaultMessage: 'Smart thermostat'
    },
    smartValve: {
        id: 'thermostat.smartValve',
        defaultMessage: 'Smart valve'
    },
    whenBackHome: {
        id: 'thermostat.whenBackHome',
        defaultMessage: 'When will you be back home?'
    }
});
